import { atom } from "recoil";

const sessionLinkAtom = atom({
  key: "sessionLinkState",
  default: false,
});

export default sessionLinkAtom;
